import React, { useContext, useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'

const UserContext = React.createContext()
export const UserProvider = ({ children }) => {
  let {loginWithRedirect, logout, user} = useAuth0();
  
  let [myUser,setMyUser] = useState(null)
  useEffect(()=>{
      setMyUser(user)
  },[user])
  
  
  return (
    <UserContext.Provider value={{loginWithRedirect, logout, myUser}}>{children}</UserContext.Provider>
  )
}
// make sure use
export const useUserContext = () => {
  return useContext(UserContext)
}
